const brand = sessionStorage.getItem('brand');

export const shared = {
  bpDropDown: {
    placeholders: {
      search: 'Traži'
    }
  },
  bpTable: {
    loadMore: 'Učitaj više',
    view: 'Pogled'
  },
  countryDropDown: {
    placeholders: {
      searchCountry: 'Pretraži državu'
    }
  },
  createNew: {
    continue: 'Nastavi',
  },
  datePicker: {
    chooseADate: 'Odaberite datum',
  },
  dateRangePicker: {
    choosePeriod: 'Odaberite razdoblje',
    today: 'Danas',
    lastWeek: 'Prošli tjedan',
    lastMonth: 'Prošli mjesec'
  },
  demoBotModal: {
    pleaseProvideNumberForTesting: 'Molimo vas da navedete broj koji želite koristiti za testiranje',
    resendOtp: 'Ponovno pošalji OTP',
    enterOtp: 'Unesite OTP',
    verifyOtp: 'Provjeri OTP',
    sendOtp: 'Pošalji OTP',
    cancel: 'Odbaci',
    placeholders: {
      phone: 'Telefon*',
      enterOtp: 'Unesite OTP*',
    }
  },
  feedback: {
    pleaseSelectYourReason: 'Odaberite razlog',
    cancel: 'Odbaci',
    submit: 'Pošalji!',
    giveFeedback: 'Dajte povratne informacije',
    ratings: 'Ocjene',
    reasonBehindYourDecision: 'Razlog vaše odluke',
    shareYourExperience: 'Podijelite svoje iskustvo',
    reason1: 'razlog1',
    reason2: 'razlog2'
  },
  feedbackModal: {
    paymentIsInProgress: 'Plaćanje je u tijeku',
    pleaseDoNotCloseThisWindow: 'Molimo vas da ne zatvarate ovaj prozor',
    placeholders: {
      name: 'Ime',
      email: 'Email*',
      phone: 'Telefon*',
      pleaseShareYourUseCase: 'Podijelite svoj upitnik'
    }
  },
  layout: {
    sidebar: {
      notifications: 'Obavijesti',
      myAccount: 'Moj račun',
      logout: 'Odjava',
      goOnline: 'Idi na mrežu',
      manage: 'Upravljaj',
      deactivate: 'Deaktiviraj',
      activate: 'Aktiviraj',
      delete: 'Izbriši',
      home: 'Početna',
      bots: 'Bots',
      inbox: 'Inbox',
      analytics: 'Analitika',
      team: 'Tim',
      subscriptions: 'Pretplate',
      more: 'Više',
      users: 'Korisnici',
      partnerTeam: 'Partner Tim',
      createNewBot: 'Stvori novog Bota',
      dashboard: 'Nadzorna ploča',
      customers: 'Kupci',
      partnerPanel: 'Panel partnera',
      raiseATicket: 'Podignite kartu',
      plans: 'Planovi',
      activities: 'Aktivnosti',
      feedbacks: 'Povratne informacije',
      emailActivity: 'Aktivnost e-pošte',
      configurations: 'Konfiguracije',
      copy: 'Kopiraj',
      developer: 'Programeri',
      yourFriendWillMissYou: 'Vaš prijatelj će vam nedostajati',
      rateYourBotCreationExperience: 'Ocijenite svoje iskustvo stvaranja bota',
      whatMadeYouDeleteYourBot: 'Što vas je natjeralo da izbrišete svog bota?',
      iCreatedByMistake: 'Stvorio sam greškom',
      iWantToCreateAnotherBot: 'Želim stvoriti još jednog Bota',
      couldNotFindFeaturesThatINeeded: 'Nisam mogao pronaći značajke koje su mi bile potrebne',
      uiWasHardToNavigate: 'UI je bio teško navigirati',
      iDonotWantToTell: 'Ne želim reći',
      other: 'Drugo',
      weWillDoOurBestToMakeAutomationFun: 'Učinit ćemo sve da automatizacija bude zabavna i jednostavna za svakoga.',
      appTooltip: {
        TOOLTIP_GO_ONLINE: 'Prekidač za omogućavanje ili blokiranje zahtjeva za razgovor uživo',
        TOOLTIP_NOTIFICATION: 'Sve obavijesti',
        TOOLTIP_MY_ACCOUNT: 'Vaš profil i sigurnost lozinke',
        TOOLTIP_LOGOUT: 'Odjava s nadzorne ploče'
      },
      modal: {
        logout: 'Odjavi se',
        botDeleteFeedbackForm: 'Obrazac za povratne informacije o brisanju Bota',
        areYouSureToLogOut: 'Jeste li sigurni da želite odjaviti?',
        yesIWillBeBack: `Da, vratit ću se`,
        deleteBot: 'Izbriši Bota',
        areYouSureToDeleteBot: 'Jeste li sigurni da želite izbrisati ovog Bota?',
        cancel: 'Odbaci',
        saveAndDelete: 'Spremi i izbriši'
      }
    }
  },
  modal: {
    cancel: 'Odbaci',
    yesDelete: 'Da, izbriši!'
  },
  notify: {
    youHave: 'Imate ',
    new: ' novi '
  },
  profileIcon: {
    appTooltip: {
      weSuggestUsingYourCompanyLogo: 'Predlažemo da odaberete logotip svoje tvrtke. Dodajte PNG ili JPG kvadratnu sliku manju od 1 MB.'
    }
  },
  upgradeModal: {
    upgradeToKingPlan: 'Ups! Baby plan nudi SAMO JEDNOG besplatnog bota. Molimo vas da nadogradite na King plan kako biste stvorili više botova.',
    noIAmGood: 'Ne, dobar sam',
    iWantToUpgrade: 'Želim nadograditi',
    oops: 'Ups! ',
    planOfferOnlyOneFreeBot: ' nudi SAMO JEDNOG besplatnog bota. Molimo vas da nadogradite na ',
    planToCreateMoreBots: ' kako biste stvorili više botova.'
  },
  webPreview: {
    preview: ' Pregled',
    botsMessages: `Poruke Bota`,
    bot: 'Bot ',
    eleven36AM: ' 11:36 AM',
    usersReply: `Korisnički odgovor`,
    landingPageBot: 'Bot za slijetanje',
    chatbot: 'Chatbot',
    chat: 'Chat',
    placeholders: {
      typeYourAnswer: 'Upišite svoj odgovor'
    }
  },
  paymentLink: {
    discardPayment: 'Odbaci plaćanje',
    completePayment: 'Završi plaćanje',
    importantUpdate: 'Važno ažuriranje',
    accountUpdate: 'Ažuriranje računa',
    youHave: 'Imate',
    exceededTheMessagesLimit: 'premašili limit poruka',
    ofYour: 'vašeg',
    planAnd: 'plana i',
    botsAreNoLongerActive: 'botovi više nisu aktivni',
    onYourWebsite: 'na vašoj web lokaciji.',
    youHaveEitherIncompletePaymentOn: 'Imate ili nepotpuno plaćanje na',
    orYouHaveNotSuccessfullyUpgradedYourPlan: 'ili niste uspješno nadogradili svoj plan.',
    orYouHaveNotSuccessfullyWhiteLabeledYourBot: 'ili niste uspješno označili svojeg Bota bijelom naljepnicom.',
    orYouHaveNotSuccessfullyPurchasedTheMessagesAddOn: 'ili niste uspješno kupili "dopunu poruka".',
    incompletePaymentMessage: 'Imate ili nepotpuno plaćanje na ili niste uspješno nadogradili svoj plan.',
    please: 'Molimo vas',
    complete: 'Završite',
    upgrade: 'Nadogradnja',
    services: 'usluge',
    yourPlanToContinueServices: 'vaš plan kako biste nastavili s uslugama',
    yourPaymentToContinue: 'vaše plaćanje kako biste nastavili',
    forAnyQueryPleaseWriteUs: 'Za bilo koji upit napišite nam na',
    close: 'Zatvori',
    writeOn: '',
    upgradePlan: 'Nadogradnja plana',
    discardModal: {
      title: 'Odbaci plaćanje',
      description: 'Jeste li sigurni da želite odbaciti plaćanje?',
      confirmText: 'Da, odbaci plaćanje'
    },
    maintenanceHeading: 'Najava nadolazećeg zakazanog održavanja:',
    maintenanceNotice: 'Usluge BotPenguin bit će privremeno nedostupne zbog održavanja 28.11.2023. od 19:00 do 19:30 IST. Ispričavamo se zbog neugodnosti. Brzo se vraćamo. Hvala na razumijevanju.'
  },
  bpExport: {
    exportStatus: 'Status izvoza',
    tasksExport: 'Zadaci - Izvoz',
    download: 'Preuzmi',
    inProgress: 'u tijeku',
  },
  singleSession: {
    close: 'Zatvori',
    useHere: 'Koristi ovdje',
    openInAnotherWindow: `${brand} je otvoren u drugom prozoru/tabu. Kliknite na "Koristi ovdje" da biste koristili ${brand} u ovom tabu.`
  }
};
